import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/boostrap/css/bootstrap.min.css'
import lodash from 'lodash'
import store from './store'

// name is optional

Vue.use(lodash, { name: 'custom' , lodash: lodash })
Vue.config.productionTip = false

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
